var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.17775 0 0 7.17744 0 16C0 24.8226 7.17775 32 16 32C24.8223 32 32 24.8226 32 16C32 7.17744 24.8223 0 16 0ZM24.3496 19.8269H7.65037C7.07419 19.8269 6.60669 19.3598 6.60669 18.7833C6.60669 18.2067 7.07419 17.7396 7.65037 17.7396H24.3497C24.9259 17.7396 25.3934 18.2068 25.3934 18.7833C25.3934 19.3598 24.9258 19.8269 24.3496 19.8269ZM24.3496 13.5647H7.65037C7.07419 13.5647 6.60669 13.0975 6.60669 12.521C6.60669 11.9444 7.07419 11.4773 7.65037 11.4773H24.3497C24.9259 11.4773 25.3934 11.9445 25.3934 12.521C25.3934 13.0975 24.9258 13.5647 24.3496 13.5647Z",
    fill: "#5A646E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/equal.71f3fa40eb523f1c25e850e7176ab54f.svg";
export { ForwardRef as ReactComponent };